// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"64b8b840","703":"93a2e233","787":"cd939c61"}[chunkId] + ".chunk.js";
};